<template>
  <div class="about">
    <section id="top">
      <Header id="header" :scrolled="true" />
    </section>

    <section id="moreInfo" class="">
      <div class="px-3 mt-5">
        <div
          class="d-block d-lg-flex flex-reverse justify-content-between px-1 px-lg-3 my-5"
        >
          <div class="col-12 col-lg-5 mt-5 mt-lg-0 mx-auto">
            <h1 class="mt-4">Sign In</h1>
            <p class="mb-5">
              <span class="text-faint">Don't have an account?</span>
              <router-link to="/signup"> Sign up</router-link>
            </p>

            <div>
              <div class="card shadow card-text border-0 mt-4">
                <div class="card-body d-flex pt-4 bg-white">
                  <img
                    src="@/assets/images/check.svg"
                    alt="icons"
                    width="16"
                    height="16"
                    class="me-3 mt-2"
                  />
                  <p>
                    Start receiving payments with developer-friendly APIs or
                    choose single string low-code or choose pre-built solutions
                    from our store.
                  </p>
                </div>
              </div>

              <div class="card shadow card-text border-0 mt-4">
                <div class="card-body d-flex pt-4 bg-white">
                  <img
                    src="@/assets/images/check.svg"
                    alt="icons"
                    width="16"
                    height="16"
                    class="me-3 mt-2"
                  />
                  <p>
                    Account Supports any business model including individual
                    payments and receivables.
                  </p>
                </div>
              </div>

              <div class="card shadow card-text border-0 mt-4">
                <div class="card-body d-flex pt-4">
                  <img
                    src="@/assets/images/check.svg"
                    alt="icons"
                    width="16"
                    height="16"
                    class="me-3 mt-2"
                  />
                  <p>
                    Online sales, POS, Agent banking, E-commerce, subscriptions,
                    SaaS platforms, marketplaces, and more—all with one account.
                  </p>
                </div>
              </div>

              <div class="mt-4">
                <p>
                  Join thousands of businesses and individuals both startups,
                  enterprises and corporates that trust Appmart.
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-5 mx-auto d-flex justify-content-center">
            <div class="col-12 col-lg-10 card shadow border-0 mt-4 pb-4">
              <div class="card-body pt-4 px-5">
                <h1 class="mt-4">Sign In</h1>
                <p class="mb-5 text-faint">
                  Sign up to create an Appmart account
                </p>

                <div>
                  <div>
                    <label for="email">Email Address</label>
                    <input
                      autocomplete="false"
                      v-model="form.email"
                      id="email"
                      class="form-control"
                      type="email"
                      placeholder="email address"
                    />
                  </div>

                  <div class="mt-4">
                    <label for="password">Password</label>
                    <input
                      autocomplete="false"
                      v-model="form.password"
                      id="password"
                      class="form-control"
                      type="password"
                      placeholder="+6 Characters"
                    />
                  </div>

                  <div class="d-flex justify-content-end mb-4 mt-2">
                    <router-link class="fs-8 a-link" to="/forgot-password">
                      Forgot Password?
                    </router-link>
                  </div>

                  <p class="mt-3 fs-7">
                    <span>
                      By clicking on the Sign in button, you agree to Appmart
                    </span>
                    <router-link to="/termsofuse">
                      terms and conditions of use.
                    </router-link>
                  </p>

                  <button
                    @click="login"
                    :disabled="!loginReady || logging"
                    class="btn mt-4 w-100"
                  >
                    <span>Sign in</span>
                    <span
                      v-if="logging"
                      class="spinner-border spinner-border-sm text-light ms-3"
                      role="status"
                    ></span>
                  </button>

                  <p class="mt-4 text-center">
                    <span class="text-faint">Don't have an account? </span>
                    <router-link to="#/signup"> Sign up</router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="footer">
      <Footer />
    </section>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { guestAxios } from "../services/AxiosInstance";
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "SignIn",

  components: {
    Header,
    Footer,
  },

  data() {
    return {
      scrollHeight: 0,
      logging: false,
      form: {
        email: null,
        password: null,
      },
    };
  },

  mounted() {
    window.onscroll = function () {
      setFixedTop();
    };

    // Get the header
    const header = document.getElementById("header");

    // Get the offset position of the navbar
    const sticky = header.offsetTop;

    // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
    const setFixedTop = () => {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    };
  },

  computed: {
    loginReady() {
      return this.form.email && this.form.password;
    },
  },

  methods: {
    ...mapActions(["saveUserInfo"]),

    async login() {
      try {
        this.logging = true;

        const api = "auth/login";
        const res = await guestAxios.post(api, {
          ...this.form,
        });

        this.logging = false;
        if (!res) {
          return;
        }

        const { data } = res;

        const user = data.data.user;

        if (!user.accountVerified) {
          this.$swal({
            icon: "error",
            text: `This account has not been verified, check you email ${user.email} for verification link!`,
          });
          return;
        }

        const token = data.data.auth.token;

        this.saveUserInfo({ user, token });

        this.$router.push({ path: "/app" });

        // clear the form
        this.form = {
          email: null,
          password: null,
        };

        this.$swal({
          toast: true,
          icon: "success",
          text: data.message,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      } catch (err) {
        console.log(err);
        this.logging = false;
      }
    },
  },
};
</script>
<style scoped>
.about {
  height: 100%;
}
.sticky {
  position: fixed;
  top: 0;
  width: 100%;
}
.about::before {
  content: "";
  background: #0b2238 !important;
  background-image: url("../assets/images/line-cc.svg");
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 0;
  pointer-events: none;
  opacity: 0.03;
}
.card-text {
  z-index: -1;
}
.card {
  min-height: 88px !important;
}
.card-body p {
  font-size: 1rem;
  color: #0b2238;
  font-weight: 400;
  line-height: 1.5;
}
input {
  height: 55px;
  color: #0b2238;
  background: #ffffff;
}
input:hover,
input:focus {
  box-shadow: none !important;
  border-color: #165df5;
}
input::placeholder {
  color: #6c7a87 !important;
}
button {
  background: #ed342b;
  color: #ffffff;
  padding: 1rem;
}
button:hover {
  color: #ffffff;
}
.text-faint {
  color: #6c7a87 !important;
}
.a-link {
  color: #0b2238;
}
.fs-7 {
  font-size: 13px !important;
}
.fs-8 {
  font-size: 14px !important;
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  #moreInfo {
    padding-left: 6rem;
    padding-right: 6rem;
  }
}
</style>
